import styled from 'styled-components';

export const StyledServices = styled.div`

.parallax {
min-height: 50vh;
display: flex;
align-items: center;
flex-direction: column;
justify-content: center;
position: relative;
}

.parallax .image {
  position: fixed; /* Important */
  top: 0; /* Important */
  left: 0; /* Important */
  width: 100%; /* Important */
  height: 100%; /* Important */
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../img/work1.jpg) no-repeat center center / cover;
  z-index: -5;
  @media only screen and (max-width: 500px) {
  position: absolute;
  }
  }

.text {
color: #FFFFFF;
text-align: center;
}

`;

export const StyledPreviewGridWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-top: 15px;
    
    @media only screen and (max-width: 700px) {
    flex-direction: column;
    }
`;
